import type { FaireProductEntity } from "../../entity_types/product";

export const p_3qstc7rzve: FaireProductEntity = {
  token: "p_3qstc7rzve",
  type: "product",
  name: "420AS Daisy Dress 5",
  brandToken: "b_m84sdvbj3h",
  brandName: "AEMI + CO",
  imageUrl:
    "https://cdn.faire.com/fastly/51871e365b958c02e687a9ccb3ac6d42f4fee57bb01b2a4a277296dbc77e0637.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2fa1dd889a3a26610fbbfb8bff65f81779f59af2e029722f316e30c0432ca319.jpeg",
    "https://cdn.faire.com/fastly/4fb610ba353cabab8289e0f52433b00a93c2f2466bcd6b6814e9d677b4d31da3.jpeg",
    "https://cdn.faire.com/fastly/319d7c7ace116650e248870c5b210d93913155c5ccd43ac386bee526bcb46065.jpeg",
    "https://cdn.faire.com/fastly/1fe6f0a42ef23d54b7c6ea2be79696225f77ab2852b34f3503ad4065079d779c.jpeg",
    "https://cdn.faire.com/fastly/1d5b2e3b2a828a4eac4a4d0d24ed92be0b0aec06e6e9716e69b8bf673197a9e2.jpeg",
    "https://cdn.faire.com/fastly/2cf3bd9685ce2ee628c7deec158be4fec4e447f47ae7c9d7d5dfb898bf008e62.jpeg",
    "https://cdn.faire.com/fastly/7c709a6ff684981a9cc2eb69e6b9b04d9615f37b46bd28d6794bbe736e665f38.jpeg",
    "https://cdn.faire.com/fastly/877b426d95ab9b3bee39cbfd4a391173d0c418cf6ff4ad6c3a5ea653db1fb887.jpeg",
    "https://cdn.faire.com/fastly/4d5c42e25958a070097260b91790c90722b5d61a34e38c160350a24b562de813.jpeg",
    "https://cdn.faire.com/fastly/f8a812f1dc14e771742bb1ca8a7ae9804f6100bbd6f56e03af9538c6e97c5f8d.jpeg",
    "https://cdn.faire.com/fastly/c28bff3f69f026a9094868cb2f02fb9ec68b47c304e58d786aff2aad76c674cc.jpeg",
    "https://cdn.faire.com/fastly/b7638869ad0e489b402c64d5f692211ec4c800ece74c3cae879f262ca964cb0a.jpeg",
    "https://cdn.faire.com/fastly/fb53af17c8caa07ab3cf3569fa90c967c3487da7b8b8793384f57b78d06b6468.jpeg",
    "https://cdn.faire.com/fastly/e32b6a74ff80055e00ea6bd07b4fc998b9e765c203707da18194774857d7ffc8.jpeg",
    "https://cdn.faire.com/fastly/375d6852fb871d5f9fcb05aedc542dd53deaf5c308c4753a765a45e21f1a4bd4.jpeg",
    "https://cdn.faire.com/fastly/8fe84b7317a022917ac211d01b2c60b5b42c6afbca2cc37ea70c5372eb5c6e92.jpeg",
    "https://cdn.faire.com/fastly/359ff5be727d4cb5b680253040463d942fe49d92f70cbda5a854039e13271d4b.jpeg",
    "https://cdn.faire.com/fastly/268ea62ce693b7d4ca9b250afe660ee776a2a3a339fb473869eb73cd88006e84.jpeg",
    "https://cdn.faire.com/fastly/69bbe174446f5059dd9a91e52fbe970767afaa251fe41c452bb4a011baae1336.jpeg",
    "https://cdn.faire.com/fastly/42656e1cde63ddc5ea9ce34573b6e5c992a5b1f99f4812196879d31735192a9a.jpeg",
    "https://cdn.faire.com/fastly/8f8953df8bb276fe197c82ca6c0c11a752710ce64410121f907eb90103c3e67b.jpeg",
    "https://cdn.faire.com/fastly/82ecc5a44400e75202f222d89af8c772bd899d77a4f48617e9f66649c6b24890.jpeg",
    "https://cdn.faire.com/fastly/0a026ebf6882c4505fc2835725eed827aff84a46f27cb8e6f5f29f6866514823.jpeg",
    "https://cdn.faire.com/fastly/ece497ab0237faec808dbc010c9a16e2855152fb25b88a4236cc33718158acc0.jpeg",
    "https://cdn.faire.com/fastly/deeca563b1d139d19b558421ab5701c00393a5fbd4da196a4b199df9f5d60b15.jpeg",
    "https://cdn.faire.com/fastly/263f34f4b66effca85b113f6dcdc75381cd20f078294f8e2d4896768f596083b.jpeg",
    "https://cdn.faire.com/fastly/ff736b728141a4d21d65c8d9bfe66b235464ceb6fa3a4a982177a1916d87a75f.jpeg",
    "https://cdn.faire.com/fastly/92f6e8b97dafe23d663f57cb61742ee4c7b753d9441f7cf0d74ebd2809731652.jpeg",
    "https://cdn.faire.com/fastly/157f76b68c5109be47f0462a72c0c2ac9a61e00f6059376ce84bd0c45dc8482f.jpeg",
    "https://cdn.faire.com/fastly/0fd227dae4eb0005ee908bd70271009a993ff64a1f0d0741ce3cceca2930c360.jpeg",
    "https://cdn.faire.com/fastly/aa545acfc824f4cb6c5b631e497f58009463070fa260ad6189c70bdb8a41e621.jpeg",
    "https://cdn.faire.com/fastly/e2b6f8da56885337d5a08c15be1466e735765715f784c3f6907c78e27eb9bbb3.jpeg",
    "https://cdn.faire.com/fastly/d73cdc2ad261f55a263b38d185ca10b472e916ac872e7e8ba56f22a8c972b73c.jpeg",
    "https://cdn.faire.com/fastly/4d3df5b157b98b4c4d09f56c40cd1ad2297cfda9d33ba50d68626272ffcedf6b.jpeg",
    "https://cdn.faire.com/fastly/a1615ea2e7d596705bcfb08d874b6a256aef73e4b2a4c2993a37b7414a0a8cbc.jpeg",
    "https://cdn.faire.com/fastly/81133659318f5b9c3bfa5c3325a369c7df4d0be6ea502c179642b95a207f17d7.jpeg",
    "https://cdn.faire.com/fastly/aa3ec7321edb180d6876157e8ce56454cabe1d4b359ef9bd47056d9dce6b1e47.jpeg",
    "https://cdn.faire.com/fastly/b4de37c6fe9e7056b892d536b889a3d52c8c8adc7f7033be5b2ee10ffebee746.jpeg",
    "https://cdn.faire.com/fastly/bd052217bcbe4df0bf56e534087b0a74c8463bda0410aac3edda28243d8ab8c5.jpeg",
    "https://cdn.faire.com/fastly/75aa012e72e333374c30520c3ec9884cf352902eeb871b3d7c48d5ce6ee5e584.jpeg",
    "https://cdn.faire.com/fastly/97a7e0142df87eaf9d08fd2a76d235f6e5ad68bd5bf22d78a66f047026f10110.jpeg",
    "https://cdn.faire.com/fastly/87da9b8b145520a238991a48c268e50d5e8c38d63ecace628bca38959ec69c28.jpeg",
    "https://cdn.faire.com/fastly/cd05700ed3d90a5738bf89c4edd2c4da2ef696f5fed78a53ad77f09502154b99.jpeg",
    "https://cdn.faire.com/fastly/fa9365110eb747ccf3f8d2c841de1867a8f8ad79f4fa6689422d2bfbcdb123fb.jpeg",
    "https://cdn.faire.com/fastly/2774c124a64d5eaf162bf50f6d76b15c13207dd393099dfb10b39352852875b8.jpeg",
    "https://cdn.faire.com/fastly/2dd2aeaa9a1f687e58ff9e5cb2340633edd48258dfe5b05d36f14a563ffc3572.jpeg",
    "https://cdn.faire.com/fastly/88268e3caf87e47ac0a2f4c7da4c75b5c0e1e3fb1e24d9caba826bcf3ea4e733.jpeg",
  ],
  priceDollars: 14.95,
  description:
    "Soft and comfy, the Daisy dress is a fair weather staple that features a shapeless tank silhouette with rounded, slit hem design and timeless waffle knit fabrication.",
  tags: [],
  msrpDollars: 33.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:47.680Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
